<template>
    <v-container fluid>
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'trainings/delete'"
			:parameters="{ id: selectItem !== null ? selectItem.id : null }"
            @on-delete="fetch">
			{{ $T('Trainings.delete-message-trainings') }}
		</v-delete-dialog>

        <div class="d-flex justify-end mb-2">
            <v-btn
            	color="secondary"
            	small
            	:to="{ name: 'training' }"
            >
                <v-icon class="me-1">$add</v-icon>
                {{$T('add-training')}}
            </v-btn>
        </div>

        <!-- table -->
        <bee-handy-table
            ref="table"
        	:headers="headers"
        	:items="trainings"
            :items-per-page="20"
            fixed-header
            :height="$vuetify.breakpoint.height - 90"
            :loading="loading"
            pagination-on-scroll
            dense
            zebra
            :data-table-props="{ disableSort: true }"
            :shown-rows-text="$T('shown-rows-text')"
            hide-shown-rows-text="auto"
            hide-default-footer
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex">
                    <v-btn
                    	icon
                    	small
                    	color="edit-color"
                        :to="{ name: 'training', params: { id: item.id } }"
                    >
                        <v-icon>$edit</v-icon>
                    </v-btn>
             
                    <v-btn 
                        @click="
                            selectItem = item
                            deleteDialog = true
                        " 
                        icon 
                        small 
                        color="alert"
                    >
                        <v-icon>$delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </v-container>
</template>

<script>
import attendance from './attendance/inner-pages/attendance';

import { mapGetters, mapState } from 'vuex';
export default {
    name: 'Trainings',
	mixins: [attendance],
    data() {
        return {
            loading: false,
            deleteDialog: false,
            storeModel: 'trainings/fetchAll',
            selectItem: null
        }
    },

    computed: {
        ...mapState({
            trainings: state => state.trainings.trainings,
        }),

        ...mapGetters({
            getEmployeeById: 'employee/getEmployeeById'
        }),

        headers() {
            const headers = [
                {
                    text: this.$T('headers.trainings.course-name'),
                    name: 'name',
                    value: 'name'
                },
                {
                    text: this.$T('headers.trainings.start-date'),
                    name: 'endDate',
                    value: 'endDate',
                    type: 'date',
                    width: 120
                },
                {
                    text: this.$T('headers.trainings.end-date'),
                    name: 'endDate',
                    value: 'endDate',
                    type: 'date',
                    width: 120
                },
                {
                    text: this.$T('headers.trainings.duration'),
                    name: 'duration',
                    value: 'duration',
                    width: 120
                },
                {
                    text: this.$T('headers.trainings.mark'),
                    name: 'coachName',
                    value: 'coachName'
                },
                {
                    text: this.$T('headers.trainings.certificate'),
                    name: 'place',
                    value: 'place'
                },
                {
                    text: this.$T('headers.trainings.course-presenter'),
                    name: 'organizers',
                    value: 'organizers'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    width: 80
                },
            ];
            for (let i = 0; i < headers.length; i++) {
                headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-2' : 'px-2';
            }
            return headers;
        }
    },

    created() {
        this.loading = true
        // this.$store.dispatch('trainings/fetchAll').finally(() => {
        //     this.loading = false;
        // })
    }
}
</script>

<style>

</style>